import { SetRoleDTO } from '../../../Domain/DTO/SetRoleDTO';
import { ListIntOptionDTO } from '../../../Domain/DTO/ListIntOptionDTO';

export class SetRoleExtendedDTO extends SetRoleDTO{
    AvailableOptions: Array<ListIntOptionDTO>;
}